import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import localforage from 'localforage';
import { persistReducer } from 'redux-persist';

export interface MapMarkupState {
  graphicsJSON: unknown[]; // Array of serialized ESRI graphics
}

const initialState: MapMarkupState = {
  graphicsJSON: [],
};

const mapMarkupSlice = createSlice({
  name: 'mapMarkup',
  initialState,
  reducers: {
    saveAllGraphics: (state, action: PayloadAction<unknown[]>) => {
      state.graphicsJSON = action.payload;
    },
    clearAllGraphics: state => {
      state.graphicsJSON = [];
    },
  },
});

interface StateWithMapMarkup {
  mapMarkup: MapMarkupState;
}

export const mapMarkupSelector = (state: StateWithMapMarkup) => {
  return state.mapMarkup;
};

export const { saveAllGraphics, clearAllGraphics } = mapMarkupSlice.actions;

const persistConfig = {
  key: 'mapMarkup',
  storage: localforage,
};

export default persistReducer(persistConfig, mapMarkupSlice.reducer);
